<div class="row text-center fondoModal">
    <div class="col-12 loading">
        <h1 class="animate__animated animate__pulse animate__infinite">Loading <span> <img class="spinner" [src]="urlIcono" width="60px">
        </span></h1>
    </div>
</div>